import { colors, HStack } from "goi_common";
import { ButtonHTMLAttributes } from "react";
import { CSSObject } from "@emotion/react";

import { MOBILE_WIDTH } from "@/constants/layout";

type FixedButtonProps = {
  cssProps?: CSSObject;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const FixedButton = (props: FixedButtonProps) => {
  const { children, cssProps, ...rest } = props;

  return (
    <HStack
      css={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: `${MOBILE_WIDTH}px`,
        padding: "12px 20px",
        zIndex: 10,
      }}
    >
      <button
        className={"button_16_sb white"}
        css={{
          width: "100%",
          background: colors.warmGray850,
          padding: "17px",
          borderRadius: "5px",
          [":disabled"]: {
            background: colors.gray200,
            color: colors.white,
            border: "none",
          },
          ...cssProps,
        }}
        {...rest}
      >
        {children}
      </button>
    </HStack>
  );
};
